/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Letterpreviewgeneratedat3Inputs */

const en_letterpreviewgeneratedat3 = /** @type {(inputs: Letterpreviewgeneratedat3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drafted ${i?.when}`)
};

const pt_letterpreviewgeneratedat3 = /** @type {(inputs: Letterpreviewgeneratedat3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Redigida ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Drafted {when}" |
*
* @param {Letterpreviewgeneratedat3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewgeneratedat3 = /** @type {((inputs: Letterpreviewgeneratedat3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewgeneratedat3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewgeneratedat3(inputs)
	return pt_letterpreviewgeneratedat3(inputs)
});
export { letterpreviewgeneratedat3 as "letterPreviewGeneratedAt" }